import { Eye } from 'lucide-react';

interface MessageMetaProps {
  /** Timestamp to display. Defaults to current time if not provided */
  timestamp?: string;
  /** View count to display. Shows "1.2K views" placeholder if not provided */
  viewCount?: number;
}

/**
 * Message metadata component showing timestamp and view count.
 * 
 * Matches the Telegram desktop appearance for channel posts.
 */
export function MessageMeta({ timestamp, viewCount }: MessageMetaProps) {
  const displayTime = timestamp ?? new Date().toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });

  const displayViews = viewCount !== undefined
    ? formatViewCount(viewCount)
    : '1.2K';

  return (
    <div className="mt-1.5 flex items-center justify-end gap-2 text-xs text-muted-foreground">
      <span className="flex items-center gap-1">
        <Eye className="h-3 w-3" />
        <span>{displayViews}</span>
      </span>
      <span>{displayTime}</span>
    </div>
  );
}

/**
 * Formats a view count with K/M suffix for large numbers.
 */
function formatViewCount(count: number): string {
  if (count >= 1_000_000) {
    return `${(count / 1_000_000).toFixed(1)}M`;
  }
  if (count >= 1_000) {
    return `${(count / 1_000).toFixed(1)}K`;
  }
  return String(count);
}
